export const MotorAddOnMasterEndpoints = (builder) => ({

    getMotorAddOns: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm,
                searchValue,
            } = args;

            const params = {
                pageNumber,
                pageSize,
            };

            // Add searchTerm and searchValue only if they are defined and not null
            if (searchTerm !== null && searchTerm !== undefined) {
                params.searchTerm = searchTerm;
            }
            if (searchValue !== null && searchValue !== undefined) {
                params.searchValue = searchValue;
            }

            return {
                url: '/MotorProduct/MotorAddOnMaster',
                method: 'GET',
                params,
            };
        },
        providesTags: ['MotorAddOnMaster'],
    }),

    getMotorAddOnById: builder.query({
        query: (id) => `/MotorProduct/GetMotorAddOnMaster/${id}`,
        providesTags: (result, error, id) => [{ type: 'MotorAddOnMaster', id }],
    }),

    saveMotorAddOn: builder.mutation({
        query: (data) => ({
            url: '/MotorProduct/SaveMotorAddOnMaster',
            method: 'POST',
            body: data,
        }),
        invalidatesTags: ['MotorAddOnMaster'],
    }),

    updateMotorAddOn: builder.mutation({
        query: ({ data }) => ({
            url: `/MotorProduct/SaveMotorAddOnMaster`,
            method: 'POST',
            body: data,
        }),
        invalidatesTags: (result, error, { id }) => [
            { type: 'MotorAddOnMaster', id },
            'MotorAddOnMaster'
        ],
    }),

    deleteMotorAddOn: builder.mutation({
        query: (id) => ({
            url: `/MotorProduct/DeleteMotorAddOnMaster/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['MotorAddOnMaster'],
    }),

    bulkDeleteMotorAddOn: builder.mutation({
        query: (body) => ({
            url: "/MotorProduct/BulkDeleteMotorAddOnMaster",
            method: "DELETE",
            body,
        }),
    }),

});